export default [{ snippet: '{{firstName}}', title: 'First name' }];
